import { Component, ElementRef, Input, OnDestroy, effect, forwardRef, viewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputUtils } from '@common/utils/input-utils';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

declare const VKI_attach: any;
declare const VKI_close: any;
declare const VKI_kbSize: any;

const ARABIC_INPUT_CONTROL_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TmwArabicInputComponent),
};

const noop = (): void => {};

@Component({
  selector: 'tmw-input-ar',
  standalone: true,
  templateUrl: './arabic-input.component.html',
  imports: [NgbDatepickerModule, FormsModule],
  providers: [ARABIC_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class TmwArabicInputComponent implements ControlValueAccessor, OnDestroy {
  _value?: any;
  _disabled: boolean = false;
  private arabicPattern: RegExp = /^[\u0600-\u06FF\s]$/;
  // @Input() required: boolean = false;
  @Input() readOnly: boolean = false;
  arField = viewChild<ElementRef>('arField');

  private onTouched: () => void = noop;
  private onChange: (_: any) => void = noop;

  get field() {
    return this._value;
  }
  set field(val) {
    if (this._value !== val) {
      this._value = val;
      this.onChange(this._value);
      this.onTouched();
    }
  }

  constructor() {
    effect(() => {
      this.initializeVirtualKeyboard();
    });
  }

  writeValue(val: any): void {
    this._value = val;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  initializeVirtualKeyboard(): void {
    // Attach the virtual keyboard to all input fields
    let myInput = this.arField()?.nativeElement;
    if (!myInput.VKI_attached) {
      VKI_kbSize(5);
      VKI_attach(myInput);
    }
  }

  removeWspace() {
    this.field = this.field.trim();
  }
  allowOnlyArabic(event: KeyboardEvent): void {
    // InputUtils.allowOnlyPattern(event, this.arabicPattern);
  }

  onPasteArabic(event: ClipboardEvent): void {
    // InputUtils.onPastePattern(event, /[^\u0600-\u06FF\s]/);
  }

  ngOnDestroy(): void {
    VKI_close();
  }
}
